import { BerlinThemeProvider } from "@src/appV2/redesign/theme/ThemeProvider";

import { MobileEditCaseContainer } from "./MobileEditCaseContainer";

export function MobileEditCasePage() {
  return (
    <BerlinThemeProvider>
      <MobileEditCaseContainer />
    </BerlinThemeProvider>
  );
}
